import { useCallback, useEffect, useState } from "react";

import { ApiPaginated, ApiResponsePaginated } from "../interfaces/paginated";
import { api } from "../services/api";

export function usePaginatedData<T>(endpoint: string) {
    const [data, setData] = useState<T[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [meta, setMeta] = useState<Omit<ApiPaginated<T>, "data">>({
        total: 0,
        per_page: 10,
        current_page: 1,
        last_page: 1,
    });

    const loadData = useCallback(async () => {
        setIsLoading(true);
        try {
            const params = new URLSearchParams();
            params.append("page", String(page));

            const separator = endpoint.includes("?") ? "&" : "?";
            const url = `${endpoint}${separator}${params.toString()}`;

            const response = await api.get<ApiResponsePaginated<T>>(url);

            if (response.data.status) {
                const { data: _data, ..._meta } = response.data.response;
                setData(_data);
                setMeta(_meta);
            }
        } catch (error) {
            console.error(`Erro ao carregar dados de ${endpoint}`, error);
        } finally {
            setIsLoading(false);
        }
    }, [endpoint, page]);

    useEffect(() => {
        loadData();
    }, [loadData]);

    const refresh = () => {
        loadData();
    };

    return {
        data,
        isLoading,
        meta,
        refresh,
        setPage,
    };
}
